import React, { Component } from 'react';

class YandexShare extends Component {

    render() {
        return <div className="ya-share2" data-services="vkontakte,facebook,odnoklassniki,moimir,twitter,lj,viber,whatsapp,skype,telegram" data-limit="3"></div>;
    }
}

export default YandexShare;